import { setQueriesDataFromKey } from '@pba/react-query';
import { type MedicalGroupDetail, createMedicalGroupDetail } from '#models';
import { useMutation, useQueryClient } from '#query';
import { getMedicalGroupsDetailQueryKey } from '#query-keys/medical-groups';
import { getMedicalGroupDetail } from '../../services';
import type { MedicalGroupDetailQueryData } from '../use-medical-group-detail';

type MedicalGroupDetailMutationVariables = {
  id: string;
};

export const useMedicalGroupDetailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MedicalGroupDetail, MedicalGroupDetailMutationVariables>({
    async mutationFn({ id }) {
      const response = await getMedicalGroupDetail({ routeParams: { id } });

      return createMedicalGroupDetail(response.data);
    },
    onSuccess(data, { id }) {
      setQueriesDataFromKey<MedicalGroupDetailQueryData>(queryClient, getMedicalGroupsDetailQueryKey({ id }), data);
    },
  });
};
